





import { computed, defineComponent } from "@vue/composition-api";
import config from "@/config";
import AppointmentOnboardingView from "./components/AppointmentOnboardingView";
import AppointmentsSettingsList from "./components/AppointmentsSettingsView";

export default defineComponent({
  name: "PageAppointmentsSettings",
  components: { AppointmentOnboardingView, AppointmentsSettingsList },
  props: {
    onboarding: { type: Boolean },
  },
  setup() {
    const canOffline = computed(() => config.featureOfflineAppointments);
    return {
      canOffline,
    };
  },
});
